import React from 'react';
import { testimonials } from '@anonymizePro/mock/contents';

function Testimonials() {
    return (
        <div className="h-full max-w-[731px] px-10 pt-[130px] text-center lg:pt-[188px] ">
            <p className="anonymize-h3 mb-10 text-black-800">{testimonials[0].thoughts}</p>
            <p className="anonymize-p2 text-black-800">{testimonials[0].author}</p>
            <p className="anonymize-p4 text-black-700">{testimonials[0].position}</p>
        </div>
    );
}

export default Testimonials;
